import React, { FC, useState } from "react";
import { kmsConnect, WrappedProps as KmsConnectProps } from "@kaltura/mediaspace-shared-kms-connect";
import { QueryParams } from "@kaltura/mediaspace-shared-types";
import SetPasswordForm, { SetPasswordFormProps } from "./SetPasswordForm";

interface Props extends Omit<SetPasswordFormProps, "onSubmit" | "processing" | "ks"> {
    onSubmit: (seed: string | undefined) => void;
    onError: () => void;
    /**
     * KS string to be submitted with the request data
     */
    ks: string;
    /**
     * the url to which password data is sent
     */
    savePasswordAction: string;
}

/**
 * Set-Password Form Container
 */
const SetPasswordFormContainer: FC<Props & KmsConnectProps> = ({
    onSubmit,
    onError,
    getFromKms,
    savePasswordAction,
    ks,
    ...rest
}) => {
    const [processing, setProcessing] = useState<boolean>(false);
    const [refreshedKs, setRefreshedKs] = useState(ks);

    // submit the form to kms
    const handleSubmit = (data: Record<string, unknown>, onValidationError: (message: string) => void) => {
        setProcessing(true);

        getFromKms
            && getFromKms(
                data as QueryParams,
                (registerResult) => {
                    setProcessing(false);
                    if (registerResult.result === true) {
                        // reset password successful
                        onSubmit(registerResult.seed);
                    }
                    else if (registerResult.errorMessage && registerResult.refreshedKs) {
                        setRefreshedKs(registerResult.refreshedKs);
                        onValidationError(registerResult.errorMessage);
                    }
                    else {
                        onError();
                    }
                },
                savePasswordAction,
                false
            );
    };

    return <SetPasswordForm onSubmit={handleSubmit} processing={processing} ks={refreshedKs} {...rest} />;
};
export default kmsConnect(SetPasswordFormContainer);
